module.exports = __webpack_public_path__ + "img/image-w.3bbe813f.svg";